var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"m-5 h-full w-full flex flex-col md:items-start md:justify-center md:flex-row gap-y-5"},[_c('AppCalendar',{staticClass:"md:w-2/3",attrs:{"calendar":_vm.calendar},model:{value:(_vm.minDate),callback:function ($$v) {_vm.minDate=$$v},expression:"minDate"}}),_c('AgendaForm',{staticClass:"mx-5 flex-grow"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }